import React, { useState } from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Materials/ViewUsageLogModal.css';

const ViewUsageLogModal = ({ material, onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortField, setSortField] = useState('date');
  const [sortAsc, setSortAsc] = useState(false);

  const filteredLogs = (material.usageHistory || [])
    .filter(item =>
      item.usedFor.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.usedBy.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (item.notes || '').toLowerCase().includes(searchQuery.toLowerCase())
    )
    .sort((a, b) => {
      if (sortField === 'quantity') {
        return sortAsc ? a.quantity - b.quantity : b.quantity - a.quantity;
      }
      return sortAsc
        ? new Date(a.date) - new Date(b.date)
        : new Date(b.date) - new Date(a.date);
    });

  return (
    <div className="view-log-modal-overlay">
      <div className="view-log-modal">
        <div className="view-log-header">
          <h3>Usage Log for {material.name}</h3>
          <button onClick={onClose}>×</button>
        </div>

        <div className="view-log-controls">
          <input
            type="text"
            placeholder="Search by use case, person, or notes"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <select value={sortField} onChange={(e) => setSortField(e.target.value)}>
            <option value="date">Sort by Date</option>
            <option value="quantity">Sort by Quantity</option>
          </select>
          <button onClick={() => setSortAsc(!sortAsc)}>
            {sortAsc ? '▲ Asc' : '▼ Desc'}
          </button>
        </div>

        {/* Desktop Table */}
        <table className="view-log-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Qty</th>
              <th>Used For</th>
              <th>By</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.length === 0 ? (
              <tr><td colSpan="5">No logs found</td></tr>
            ) : (
              filteredLogs.map((log, i) => (
                <tr key={i}>
                  <td>{new Date(log.date).toLocaleDateString('en-IN')}</td>
                  <td>{log.quantity}</td>
                  <td>{log.usedFor}</td>
                  <td>{log.usedBy}</td>
                  <td>{log.notes || '-'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Mobile Cards */}
        <div className="view-log-cards">
          {filteredLogs.map((log, i) => (
            <div className="view-log-card" key={i}>
              <div><strong>Date:</strong> {new Date(log.date).toLocaleDateString('en-IN')}</div>
              <div><strong>Quantity:</strong> {log.quantity}</div>
              <div><strong>Used For:</strong> {log.usedFor}</div>
              <div><strong>Used By:</strong> {log.usedBy}</div>
              <div><strong>Notes:</strong> {log.notes || '-'}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ViewUsageLogModal;
